<template>
    <vue-modal
        v-model="visible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :modalBodyClass="$prefixClass.modal + '-subscribe-image'"
    >
        <h4 class="m-b-16">{{ $t('app.subscribe_image.title') }}</h4>
        <p class="m-b-24" v-html="$t('app.subscribe_image.description')"></p>
        <a-button class="m-b-8" type="primary" @click="subscribe">{{ $t('app.buttons.subscribe_now') }}</a-button><br>
        <a-button type="subtle" @click="buyMoreImage">{{ $t('app.buttons.buy_more_images') }}</a-button>
    </vue-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { types as typesCharge } from '@/modules/charge/constant'
import { types as typesAuth } from '@/modules/auth/constant'
import cookie from 'js-cookie'
export default {
    name: 'VueModalSubscribeImage',
    props:{
        value: {
            type: Boolean,
            required: true
        }
    },
    data(){
        return{
        }
    },
    computed: {
        ...mapGetters({
            store : typesAuth.getters.GET_STORE
        }),
        visible: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    created() {
    },
    methods:{
        ...mapActions({
            handleChargePlan: typesCharge.actions.HANDLE_CHARGE_PLAN,
        }),
        subscribe() {
            let self = this
            this.visible = false
            this.handleChargePlan({plan: this.store.app_plan, discount_code: '', used_trial: false }).then( res => {
                let { status, data } = res.data
                if(status){
                    window.location.href = data.redirect_url
                }
            })
        },
        buyMoreImage() {
            this.visible = false
            this.$emit('buy-more-images')
        }
    }
}
</script>
<style lang="scss">
    .m-modal-subscribe-image {
        width: 512px !important;
        .m-modal {
            &-body {
                padding: 40px 0 30px 0;
                text-align: center;
                .a-btn-subtle {
                    color: $text-color-secondary;
                }
            }
        }
    }
</style>

